import {
    FETCH_DETALLES_SUCCESS,
    FETCH_DETALLES_FAILURE,
    CREATE_DETALLE_SUCCESS,
    CREATE_DETALLE_FAILURE,
    UPDATE_DETALLE_SUCCESS,
    UPDATE_DETALLE_FAILURE,
    DELETE_DETALLE_SUCCESS,
    DELETE_DETALLE_FAILURE,
  } from '../actions/ingresoDetalleActions';
  
  const initialState = {
    detalles: [],
    error: null,
  };
  
  const ingresoDetalleReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_DETALLES_SUCCESS:
        return { ...state, detalles: action.payload, error: null };
      case CREATE_DETALLE_SUCCESS:
        return { ...state, detalles: [...state.detalles, action.payload], error: null };
      case UPDATE_DETALLE_SUCCESS:
        return {
          ...state,
          detalles: state.detalles.map(detalle =>
            detalle.id === action.payload.id ? action.payload : detalle
          ),
          error: null,
        };
      case DELETE_DETALLE_SUCCESS:
        return {
          ...state,
          detalles: state.detalles.filter(detalle => detalle.id !== action.payload),
          error: null,
        };
      case FETCH_DETALLES_FAILURE:
      case CREATE_DETALLE_FAILURE:
      case UPDATE_DETALLE_FAILURE:
      case DELETE_DETALLE_FAILURE:
        return { ...state, error: action.payload };
      default:
        return state;
    }
  };
  
  export default ingresoDetalleReducer;